import { useEffect, useState } from "react";
import { performantUpdate } from "../dom";
import { Dimensions } from "./common";

export const useWindowDimensions = (): Dimensions => {
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const getDimensions = (): Dimensions => {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    };
    setDimensions(getDimensions());

    const cb = performantUpdate(() => {
      setDimensions(getDimensions());
    });

    window.addEventListener("resize", cb, {
      passive: true,
    });

    return () => window.removeEventListener("resize", cb);
  }, []);

  return dimensions;
};
